import { admin2 } from '@/api/instance'

const baseUrl = (shopId) => `/${shopId}/signatureRecordMapping`

/**
 * 取得同意書發放紀錄列表 admin.signatureRecordMapping.find
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.templateName] - 同意書名稱（模糊搜尋）
 * @param {string} [params.status] - 簽署狀態 (unsigned|signed|expired)
 * @param {string} [params.memberNameOrPhone] - 會員姓名或電話（模糊搜尋）
 * @param {string} [params.MemberId] - 會員ID
 * @param {number} [params.start=0] - 分頁起始
 * @param {number} [params.limit=20] - 每頁筆數
 * @returns {Promise<Array>} 同意書發放紀錄列表
 */
export const GetSignatureRecordMapping = async ({
  shopId,
  templateName,
  status,
  memberNameOrPhone,
  MemberId,
  start,
  limit,
}) => {
  return admin2({
    method: 'GET',
    url: baseUrl(shopId),
    params: {
      templateName,
      status,
      memberNameOrPhone,
      MemberId,
      start,
      limit,
    },
  })
}

/**
 * 取得同意書發放紀錄數量 admin.signatureRecordMapping.count
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} [params.templateName] - 同意書名稱（模糊搜尋）
 * @param {string} [params.status] - 簽署狀態 (unsigned|signed|expired)
 * @param {string} [params.memberNameOrPhone] - 會員姓名或電話（模糊搜尋）
 * @param {string} [params.MemberId] - 會員ID
 * @returns {Promise<Object>} 同意書發放紀錄數量
 */
export const GetSignatureRecordMappingCount = async ({
  shopId,
  templateName,
  status,
  memberNameOrPhone,
  MemberId,
}) => {
  return admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/count`,
    params: {
      templateName,
      status,
      memberNameOrPhone,
      MemberId,
    },
  })
}

/**
 * 取得單筆同意書發放紀錄 admin.signatureRecordMapping.findOne
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 簽名紀錄ID
 * @returns {Promise<Object>} 同意書發放紀錄詳情
 */
export const FindSignatureRecordMapping = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}`,
  })
}

/**
 * 建立同意書發放紀錄 admin.signatureRecordMapping.create
 * @param {Object} params - 建立參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.SignatureTemplateId - 同意書模板ID
 * @param {string} params.MemberId - 會員ID
 * @param {number} params.signDeadlineDays - 簽署期限天數
 * @returns {Promise<Object>} 建立結果
 */
export const CreateSignatureRecordMapping = async ({
  shopId,
  SignatureTemplateId,
  MemberId,
  signDeadlineDays,
}) => {
  return admin2({
    method: 'POST',
    url: baseUrl(shopId),
    data: {
      SignatureTemplateId,
      MemberId,
      signDeadlineDays,
    },
  })
}

/**
 * 取得已簽署 PDF 下載連結 admin.signatureRecordMapping.getSignedFile
 * @param {Object} params - 下載參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 簽名紀錄ID
 * @returns {Promise<Object>} 下載連結
 */
export const GetSignatureRecordMappingSignedFile = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}/signedFile`,
  })
}

/**
 * 取得簽署連結 admin.signatureRecordMapping.getSignatureLink
 * @param {Object} params - 查詢參數
 * @param {string} params.shopId - 商店ID
 * @param {string} params.id - 簽名紀錄ID
 * @returns {Promise<Object>} 簽署連結
 */
export const GetSignatureRecordMappingSignatureLink = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `${baseUrl(shopId)}/${id}/signatureLink`,
  })
}
